import { render, staticRenderFns } from "./CustomerPointsTab.vue?vue&type=template&id=6b28e330&scoped=true"
import script from "./CustomerPointsTab.vue?vue&type=script&lang=js"
export * from "./CustomerPointsTab.vue?vue&type=script&lang=js"
import style0 from "./CustomerPointsTab.vue?vue&type=style&index=0&id=6b28e330&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b28e330",
  null
  
)

export default component.exports